const formatEmail = (email: string): string => {
  if (!email || typeof email !== 'string') {
    return '';
  }

  return email.replace(/\s/g, '').replace(/^mailto:/i, '');
};

export default formatEmail;
